module.exports = __webpack_public_path__ + "static/media/club_banner_1.19114c52.jpg";